'use strict';

var _require = require('./baseProperties'),
    baseProperties = _require.baseProperties;

module.exports.VeranstaltungSchema = {
  title: 'Veranstaltung',
  type: 'object',
  properties: Object.assign({}, baseProperties, {
    veranstaltungEnde: {
      type: 'string',
      format: 'date-time'
    },
    veranstaltungStart: {
      type: 'string',
      format: 'date-time'
    }
  })
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/schema/veranstaltung.js
// module id = XGlO
// module chunks = 0